import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxSummernoteModule } from 'ngx-summernote';
import { UserDetailModalComponent } from './user-detail-modal/user-detail-modal.component';
import { UserExportComponent } from './user-export/user-export.component';
import {NgxSummernoteCustomModule} from '../../lib/ngx-summernote-custom.module';


@NgModule({
  declarations: [UserComponent, UserDetailModalComponent, UserExportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    SharedModule,
    NgxBarcodeModule,
    NgxSummernoteCustomModule,
    UserRoutingModule
  ]
})
export class UserModule { }
